var Flickity = require('flickity');
require('flickity-as-nav-for');

var PhotoSwipe = require('photoswipe');
var PhotoSwipeUIDefault = require('photoswipe/dist/photoswipe-ui-default');

export default {
  init() {

    // Image Carrousel
    var productGallery = document.querySelector('.product__images');
    if (productGallery) {
      var imgFlkty = new Flickity(productGallery,{
        prevNextButtons: false
      });
    }

    var productThumbnails = document.querySelector('.product__thumbnails');
    if (productThumbnails) {
      var thumbnailsCells = productThumbnails.querySelectorAll('li');
      thumbnailsCells = Array.from(thumbnailsCells);

      for(var i=0; i < thumbnailsCells.length; i++) {
        (function(index){
          thumbnailsCells[i].addEventListener('click', (e)=>{
            imgFlkty.select(index);
            thumbnailsCells.forEach(item => {
              item.classList.remove('is-current');
            })
            e.target.classList.add('is-current');
          });
        })(i);
      }

      imgFlkty.on('change', function(index) {
        const curThumb = document.querySelector('li.is-current');
        if(curThumb) {
          curThumb.classList.remove('is-current');
        }
        const newThumb = thumbnailsCells[index];
        console.log(newThumb);
        newThumb.classList.add('is-current');
      });
    }

    // PhotoSwipe
    var items = [];
    var productImages = document.querySelectorAll('.product__image');
    if( productImages ) {
      productImages.forEach((image) => {
        var href = image.getAttribute('data-full-img');
        var size = image.getAttribute('data-full-size');
        size = size.split('x');
        var width = size[0];
        var height = size[1]
        var item = {
          src : href,
          w   : width,
          h   : height
        }
        items.push(item);
      });
    }
    // console.table(items);
    var zoomBtn = document.querySelector('.product__zoom');
    zoomBtn.addEventListener('click', (e)=> {
      e.preventDefault();
      var pswp = $('.pswp')[0];
      let curIndex = 0
      if(productThumbnails) {
        curIndex = imgFlkty.selectedIndex;
      }


      var options = {
        index: curIndex,
        barsSize: {
          top:0,
          bottom:'auto'
        },
        bgOpacity: 0.8,
        showHideOpacity: true,
        captionEl: false,
        shareEl: false,
        fullscreenEl: false,
      }

      var lightBox = new PhotoSwipe(pswp, PhotoSwipeUIDefault, items, options);
      lightBox.init();
      return false;
    });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/product.js